import { Layout } from "@/components/Layout";
import { ArmadaSectorList } from "@/components/ArmadaSectorList";
import { Compass } from "lucide-react";
import { ARMADA } from "@/constants/testIds";

export default function Armada() {
  return (
    <Layout>
      <section className="relative py-20 px-6 md:px-12 lg:px-20" data-testid={ARMADA.pageHero}>
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <Compass className="text-[#C9A227]"/>
            <span className="label-gold">EIGOO Ecosystem · Armada Sector Catalog</span>
          </div>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-white leading-[0.95] max-w-4xl">
            10 Sectors. <span className="gold-shimmer">One Armada.</span>
          </h1>
          <p className="text-white/60 mt-6 max-w-2xl">
            Pacific Siren is the flagship hull of a 10-sector fleet. Each sector is a sovereign territory available for the right commander. If you command authority in any of these — or beyond — launch your signal.
          </p>
          <div className="mt-14">
            <ArmadaSectorList />
          </div>
          <div className="glass mt-16 p-8 md:p-12 border border-[#C9A227]/30 grid md:grid-cols-[1fr_auto] gap-6 items-center">
            <div>
              <span className="label-gold">Beyond the Catalog</span>
              <h2 className="text-2xl md:text-3xl font-black uppercase tracking-tight text-white mt-2 leading-tight">
                Commanding a sector that isn't listed?
              </h2>
              <p className="text-white/60 text-sm mt-3 max-w-xl">
                The Armada is built to expand. Send EIGOO your sovereignty claim and the fleet will be architected around your authority.
              </p>
            </div>
            <a href="mailto:command@eigooinc.net" className="btn-gold text-xs whitespace-nowrap">
              Send Direct Signal
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
